/**
 * Only absolute https URLs may go into an `iframe src` — React does not sanitize that sink in
 * a production build, and we ship no `frame-src` CSP.
 *
 * @returns the parsed URL, or `null` if it must not be framed
 */
export function parseFramableUrl(url?: string | null): URL | null {
  if (!url) return null

  try {
    const parsed = new URL(url)

    return parsed.protocol === 'https:' ? parsed : null
  } catch {
    return null
  }
}
